import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=d79aabf6&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=ts&"
export * from "./Skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=d79aabf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79aabf6",
  null
  
)

export default component.exports